/*
 LinksPlatnosci

 "Linki" do platnosci
  
 historia: 
  PM 2021-10-12 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';
import { Aplikacja } from '../App';

interface LinksPlatnosciProps {
    setAplikacja: (aAplikacja: Aplikacja) => void,
    platnosci: Aplikacja[]
}

class LinksPlatnosci extends React.Component<LinksPlatnosciProps & WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                {this.props.platnosci.map((aplikacja, index) => (
                    <Typography key={aplikacja.text} variant="h6" component="h2" style={{ paddingTop: "5px", paddingBottom: (index + 1) === this.props.platnosci.length ? "5px" : '' }}>
                        {'- '}
                        <Button
                            variant="text"
                            color="secondary"
                            size="large"
                            onClick={() => this.props.setAplikacja(aplikacja)}
                            className={`${classes.link} ${classes.button}`}
                        >
                            {aplikacja.text}
                        </Button>
                    </Typography>
                ))}
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    link: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
    button: {
        padding: 0,
        fontSize: '12px',
        lineHeight: '19.2px',
        letterSpacing: '0.09px',
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    }
});

export default withStyles(styles)(LinksPlatnosci);
